export const range = (start: number, end: number): Array<number> => Array.from(
    { length: end - start + 1 },
    (__: number, k: number) => k + start,
);
